import { ReactNode, createContext, useContext } from "react";

export interface ToastSettings {
  id?: string;
  title: ReactNode;
  type?: "success" | "error" | "info";
  onPress?: () => void;
}

interface Toasts {
  show: (toast: ToastSettings) => void;
  close: (id?: string) => void;
}

export const ToastContext = createContext<Toasts>({
  /** @deprecated use showToast directly instead */
  show() {
    console.warn(
      "Attempted to show a toast but can't find a ToastContext.Provider."
    );
  },
  /** @deprecated */
  close() {
    console.warn(
      "Attempted to close a toast but can't find a ToastContext.Provider."
    );
  },
});

/** @deprecated use showToast directly instead */
export const useToasts = () => {
  return useContext(ToastContext);
};
